export default "__VITE_ASSET__DywrHxFy__"